export default  {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: require('../views/property.contact.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.contact.component.js